module.exports = __webpack_public_path__ + "img/_icon_team.fa488150.svg";